import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getAccount } from '../services/accountService';
import { useAuth } from './AuthContext';

const ThemeContext = createContext({});

const CSS_VAR_MAP = {
  corPrimaria: '--primary',
  corAcento: '--accent',
  corTexto: '--text',
  corFundo: '--surface',
  corSidebar: '--sidebar-bg',
  corSidebarTexto: '--sidebar-text',
  corSidebarAtivo: '--sidebar-active',
  fontFamily: '--font',
};

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAccount = useCallback(async () => {
    if (!user) {
      setAccount(null);
      setLoading(false);
      return;
    }
    try {
      const data = await getAccount(user.uid);
      setAccount(data);
      applyTheme(data);
    } catch (err) {
      console.error('Erro ao carregar conta:', err);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    loadAccount();
  }, [loadAccount]);

  const applyTheme = (data) => {
    if (!data) return;
    const root = document.documentElement;
    Object.entries(CSS_VAR_MAP).forEach(([key, cssVar]) => {
      if (data[key]) root.style.setProperty(cssVar, data[key]);
    });
    // Favicon
    if (data.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = data.faviconUrl;
    }
    // Title
    if (data.nomeEmpresa) {
      document.title = data.nomeEmpresa;
    }
  };

  const updateAccount = (newData) => {
    setAccount((prev) => {
      const updated = { ...prev, ...newData };
      applyTheme(updated);
      return updated;
    });
  };

  return (
    <ThemeContext.Provider value={{ account, loading, updateAccount, reloadAccount: loadAccount }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);